import React from "react";
export default (props: any) => null
